import { ReactElement } from 'react';

export function Awards(): ReactElement {
  return (
    <>
      <div className="container news-content">
        <h4>Awards and Honors</h4>
        <div className="clearfix"> </div>
        <ul className="news-list">
          <li>
            <b>Sep. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/ficfinder/index.html">
              FicFinder
            </a>{' '}
            received <strong>ACM SIGSOFT Distinguished Paper Award</strong> in
            ASE 2016 [
            <a href="http://www.cse.ust.hk/News/SIGSOFT2016/">News link</a>]
          </li>
          <li>
            <b>Jul. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/elite/">Elite</a> was evaluated as{' '}
            <strong>Platinum Artifact</strong> in FSE 2016
          </li>
          <li>
            <b>May 2016: </b>Prof. Shing-Chi Cheung received{' '}
            <strong>Distinguished Reviewer Award</strong> in ICSE 2016
          </li>
          <li>
            <b>Apr. 2016: </b>
            <a href="http://sccpu2.cse.ust.hk/csnippex/index.html">
              CSNIPPEX
            </a>{' '}
            was accepted as <strong>Evaluated Artifact</strong> in ISSTA 2016
          </li>
          <li>
            <b>Jan. 2016: </b>Chang Xu received{' '}
            <strong>CCF Young Computer Scientist Award</strong> [
            <a href="materials/CCF_scientist.pdf">Certificate</a>]
          </li>
          <li>
            <b>Oct. 2015: </b>Ming Wen received{' '}
            <strong>School of Engineering (SENG) PhD Fellowship Award</strong>,
            SENG HKUST, 2014-2015.
          </li>
          <li>
            <b>Sep. 2014: </b>
            <a href="http://sccpu2.cse.ust.hk/greendroid/index.html">
              GreenDroid
            </a>{' '}
            was selected as the <strong>feature article</strong> of TSE in the
            issues of September 2014 [
            <a href="http://www.cse.ust.hk/News/IEEETSE2014/">News link</a>]
          </li>
          <li>
            <b>Sep. 2014: </b> Chang Xu received{' '}
            <strong>ACM Nanjing Rising Star Award</strong> [
            <a href="materials/NanjingStar.pdf">Certificate</a>]
          </li>
          <li>
            <b>Nov. 2014: </b>Yepang Liu received ACM SIGSOFT Service
            Recognition Award at FSE 2014 [
            <a href="http://sccpu2.cse.ust.hk/andrewust/files/FSE2014_SRA.pdf">
              Certificate
            </a>
            ]
          </li>
          <li>
            <b>Nov. 2014: </b>Yepang Liu received ACM SIGSOFT Service Award at
            FSE 2014 [
            <a href="http://sccpu2.cse.ust.hk/andrewust/files/FSE2014_SA.pdf">
              Certificate
            </a>
            ]
          </li>
          <li>
            <b>Jul. 2014: </b>
            <a href="http://sccpu2.cse.ust.hk/wurongxin/CrashLocator/index.html">
              CrashLocator
            </a>{' '}
            received <strong>ACM SIGSOFT Distinguished Paper Award</strong> in
            ISSTA 2014 [
            <a href="https://www.cse.ust.hk/News/SIGSOFT2014/ISSTA/">
              News link
            </a>
            ]
          </li>
          <li>
            <b>Jul. 2014: </b> SHAP received <strong>Best Paper Award</strong>{' '}
            from APSEC 2014 [<a href="materials/APSEC.pdf">Certificate</a>]
          </li>
          <li>
            <b>May 2014: </b>
            <a href="http://sccpu2.cse.ust.hk/perfchecker/">PerfChecker</a>{' '}
            received <strong>ACM SIGSOFT Distinguished Paper Award</strong> in
            ICSE 2014 [
            <a href="https://www.cse.ust.hk/News/SIGSOFT2014/">News link</a>] [
            <a href="materials/PerfChecker_Award.pdf">Certificate</a>]
          </li>
          <li>
            <b>Sep. 2012: </b>Chang Xu received <strong>CVIC SE Talents</strong>{' '}
            [<a href="materials/CVIC.pdf">Certificate</a>]
          </li>
          <li>
            <b>Sep. 2011: </b>Chang Xu received{' '}
            <strong>
              National Science and Technology Progress Award (Second Class,
              7/10)
            </strong>{' '}
            [
            <a href="materials/National_Science_and_Technology_Progress_Award.pdf">
              Certificate
            </a>
            ]
          </li>
          <li>
            <b>May 2011: </b> Chang Xu received{' '}
            <strong>
              New Century Excellent Talents in University by the Ministry of
              Education
            </strong>
          </li>
        </ul>
      </div>
    </>
  );
}
